import React, { useState, useEffect, useRef } from 'react';
import LoadingSpinner from '../components/layout/LoadingSpinner';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../components/auth-context/AuthContext';
import { login as loginAction } from '../features/auth/authSlice';


const Nucleus = () => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const dispatch = useDispatch();
    const { login: authLogin } = useAuth();
    const [url, setUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const nucleusDomain = process.env
        .REACT_APP_NUCLEUS_ACTIVE_TEACH_URL as string;
    const [user, setUser] = useState<any>({});
    const [selectedSchoolId, setSchoolId] = useState<number | null>(null);
    const token = useSelector((state: RootState) => state.auth.token);
    const productType = useSelector((state: RootState) => state.product);
    useEffect(() => {
        if (token) {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                let userData = JSON.parse(storedUser);
                userData.su = userData.su.filter(
                    (su: any) => su.schoolStatusId || su.schoolstatusid === 1
                );
                setUser(userData);
                setSchoolId(userData.su[0].schoolid || userData.su[0].id);

                let { su, ...userWithoutSu } = userData;

                let userDataParam = {
                    user: userWithoutSu,
                    auth_token: token,
                    toolbar: false,
                    productType: productType,
                    xClientApp: productType,
                    selectedAcadYear: userData.su[0].acadyears[0] || userData.su[0].acadyears[0],

                };
                let encodedUserSessionData = btoa(JSON.stringify(userDataParam));
                let nucleusURL = `${process.env.REACT_APP_NUCLEUS_ACTIVE_TEACH_URL}/v2/migrated/${userData.su[0].schoolid || userData.su[0].id}/active-teach?data=${encodedUserSessionData}`;
                setUrl(nucleusURL);
            }
        }
    }, [token]);

    const handleLoad = () => {
        setIsLoading(false);
    };

    // Handle messages from the iframe
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== nucleusDomain) {
                console.warn('Origin mismatch:', event.origin);
                return;
            }

            // Handle the response from the iframe
            if (event.data?.type === 'LOCAL_STORAGE_DATA') {
                // Add a new key-value pair to the parent's localStorage
                localStorage.setItem('new_key', 'new_value');
                if (event.data.academic_code) {
                    localStorage.setItem(
                        'academicCode',
                        event.data.academicCode
                    );
                }

                // Example: Adding data from iframe's localStorage to parent's localStorage
                if (event.data.user_data) {
                    localStorage.setItem('userNEW', event.data.user_data);
                }

                if (event.data.auth_token) {
                    localStorage.setItem('tokenNEW', event.data.auth_token);
                }
            }

            if (event.data.type === 'ACTIVE_TEACH_AUTH_INIT') {
                const receivedData = event.data;
                const stored = localStorage.getItem('user');
                const localtoken = localStorage.getItem('token');
                if (stored && localtoken) {
                    let storedLocal = JSON.parse(stored);
                    let selSch = JSON.parse(receivedData.selSch);
                    let selAcadData = receivedData.selAcadData ? JSON.parse(receivedData.selAcadData) : null;
                    localStorage.setItem('selSch', receivedData['selSch']);
                    console.log("user", user);
                    storedLocal.su.unshift(selSch[0]);
                    // storedLocal.su = selSch;
                    localStorage.setItem('user', JSON.stringify(storedLocal));
                    authLogin(storedLocal, localtoken);
                    dispatch(
                        loginAction({ user: storedLocal, token: localtoken })
                    ); // Save user data and token in Redux store
    
                    setSchoolId(storedLocal.su[0].schoolid || storedLocal.su[0].id);

                    let { su, ...userWithoutSu } = storedLocal;

                    let userDataParam = {
                        user: userWithoutSu,
                        auth_token: localtoken,
                        toolbar: false,
                        productType: productType,
                        xClientApp: productType,
                        selectedAcadYear: selAcadData || storedLocal.su[0].acadyears[0] || storedLocal.su[0].acadyears[0],
                    };
                    let encodedUserSessionData = btoa(JSON.stringify(userDataParam));
                    let nucleusURL = `${process.env.REACT_APP_NUCLEUS_ACTIVE_TEACH_URL}/v2/migrated/${storedLocal.su[0].schoolid || storedLocal.su[0].id}/active-teach?data=${encodedUserSessionData}`;
                    setUrl(nucleusURL);
                }
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <div
            className="w-full h-full"
            style={{
                padding: '0.5rem 0.5rem 0 0.6rem',
            }}
        >
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                    <LoadingSpinner />
                </div>
            )}
            <iframe
                ref={iframeRef}
                className="content-iframe w-full h-full transition-opacity duration-500 ease-in-out"
                title="Nucleus"
                src={url}
                onLoad={handleLoad}
                style={{
                    opacity: isLoading ? 0 : 1,
                }}
            ></iframe>
        </div>
    );
};

export default Nucleus;
